module.exports = __webpack_public_path__ + "img/bg-about.15f96a63.jpg";